import { supabase } from '../supabaseClient';
import { getApiUrl } from './platform';

export async function agentFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    const error = new Error('Please sign in again.');
    error.code = 'unauthorized';
    throw error;
  }
  const response = await fetch(getApiUrl(path), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
      ...(options.headers || {}),
    },
  });
  let body = {};
  try {
    body = await response.json();
  } catch (err) {
    body = {};
  }
  return { ok: response.ok, status: response.status, body };
}

export function inviteErrorMessage(code) {
  switch (code) {
    case 'unsubscribed':
    case 'suppressed':
      return "Can't email: unsubscribed";
    case 'bounced':
      return "Can't email: bounced";
    case 'complained':
      return "Can't email: the recipient marked a previous email as spam";
    case 'invite_cap':
      return 'Today\'s invite limit is reached. The rest stay unsent until tomorrow.';
    case 'resend_limit':
      return 'This homeowner already received the one reminder.';
    case 'unsubscribe_not_configured':
      return 'Invites are off until unsubscribe is configured.';
    case 'postal_address_not_configured':
      return 'Invites are off until the postal address is configured.';
    case 'resend_wait':
      return 'Wait 24 hours before sending this invite again.';
    case 'already_joined':
      return 'This homeowner has already joined.';
    case 'email_not_configured':
      return 'Email sending is not configured.';
    case 'provider_rejected':
      return "Couldn't send the email.";
    case 'not_found':
      return 'That homeowner is not on your list.';
    default:
      return code ? "Couldn't send the email." : '';
  }
}

export function inviteColumnLabel(client) {
  if (!client) return 'Not sent';
  if (client.status === 'active' || client.invite_status === 'accepted') {
    if (client.has_password === false) return 'No password';
    return 'Joined';
  }
  if (client.invite_status === 'suppressed') return "Can't email";
  if (client.invite_status === 'failed') return 'Failed';
  if (client.invite_status === 'sent') {
    if (!client.invite_last_sent_at) return 'Sent';
    const when = new Date(client.invite_last_sent_at);
    if (Number.isNaN(when.getTime())) return 'Sent';
    return `Sent ${when.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}`;
  }
  return 'Not sent';
}
